import { $config } from "../environments";
import "./setup";
import { Module } from "./module";
import { polyfill } from "./help/polyfill";
import {
  DomRelated,
  Form,
  Pagination,
  Detail,
  Path,
  Video,
  Login,
  File,
  Navs,
  Tab,
  fileDetail,
  searchDetail,
} from "./controllers";
import { $dom } from "./common/dom";
import { Nav } from "./dom/navToggle";
import "common/url";
let $sk: any = polyfill().$sk;

if (!$sk) {
  $sk = {};
}

if (!$sk.template) {
  $sk.template = {
    isNotTemp: true,
    module() {},
    update() {},
    get() {
      return {
        user: {},
        common: {},
      };
    },
  };
}

$sk.$cms_config = $config;
$sk.cms = new Module();
$sk.cms
  .module("$$core", [
    DomRelated,
    Form,
    Nav,
    Navs,
    Video,
    Login,
    File,
    Pagination,
    Path,
    Tab,
    searchDetail,
  ])
  .bootstrap("$$core");
$sk.cms.module("$$artDetail", [Detail]);
$sk.cms.module("$$fileDetail", [fileDetail]);
$sk.cms.module("$$searchDetail", [searchDetail]);

$sk.backToTop = (t) => {
  $dom.fanhui(t);
};

export { $sk };
